/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 首页主体
 **/
<template>
    <div class="hContent">
        <div class="content">
            <div class="readComit">
                <h3>走进通易</h3>
                <p>快速了解企业概况，开启通易之旅</p>
            </div>
        </div>
        <div class="readCon">
            <div class="conBox">
                <div class="conImg" @click="goto('/comabout/synopsis')" ></div>
                <div class="conTextBold">公司简介</div>
                <div class="conTextLow">Company profile</div>
            </div>
            <div class="conBox">
                <div class="conImg"  @click="gotoNews()" ></div>
                <div class="conTextBold">公司动态</div>
                <div class="conTextLow">News and trends</div>
            </div>
            <!-- <div class="conBox">
                <div class="conCenterTop">
                    <div class="conTextBold conTextCenter">公司动态</div>
                    <div class="conTextLine"></div>
                </div>
                <div class="conCenterCon">
                    <div class="conNews" v-for="(item,index) in newArrCom" :key="index"><p @click="gotoNews()">{{item.title}}</p><span>{{item.dataTime}}</span></div>
                    <div class="conMore"><p>了解更多></p></div>
                </div>
            </div> -->
            <div class="conBox">
                <div class="conImg" @click="goto('comculture/care')"></div>
                <div class="conTextBold">员工关怀</div>
                <div class="conTextLow">Employees care</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            newArr:[
                {
                    title:'江西省公路治理超限超载综合管理平台应用软件开发项目启动会',
                    dataTime:'2019-12-27',
                    newText:'我是新闻'
                },
                {
                    title:'广州通易科技有限公司新版官网',
                    dataTime:'2019-12-27',
                    newText:'我是新闻'
                },
                {
                    title:'2019年通易科技有限公司年度总结',
                    dataTime:'2019-12-27',
                    newText:'我是新闻'
                },
                {
                    title:'2020年通易科技有限公司计划安排以及新春开工时间',
                    dataTime:'2019-12-27',
                    newText:'我是新闻'
                },
                {
                    title:'和部分公司达成协议，即将推出新的服务',
                    dataTime:'2019-12-27',
                    newText:'我是新闻'
                },
            ],
        }
    },
    methods:{
        goto:function(i){
            this.$router.push(i)
        },
        gotoNews:function(){
            this.$router.push('news')
        }
    },
    computed: {
        newArrCom:function(){
            let newarr = [...this.newArr]
            if(newarr.length>=5){
                newarr.length = 5;
            }
            return newarr;
        },
    },
}
</script>

<style lang="scss" scoped>
    .hContent{
        // height: 770px;
        .content{
            width: 1200px;
            height: 100%;
            margin: auto;
            .readComit{
                width: 100%;
                height: 12.9375rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                h3{
                    color: #222;
                    font-size: 2rem;
                    height: 2rem;
                    line-height: 2rem;
                    margin-bottom: 1.75rem;
                }
                p{
                    font-size: 1.25rem;
                    line-height: 1.25rem;
                    height: 1.25rem;
                    color: #999
                }
            }
        }
        .readCon{
            height: 35.1875rem;
            width: 100%;
            display: flex;
            justify-content: space-between;
            min-width: 75rem;
            .conBox{
                height: 31.375rem;
                width: 32%;
                background: #EEF4F7;
                .conImg{
                    width: 100%;
                    height: 21.875rem;
                    background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_gsjj.png) no-repeat bottom center;
                    // background-size: 100% 100%;
                    background-size: 125% 102%;
                    margin-bottom: 2.4375rem;
                    cursor: pointer;
                    // transition: background-size 1s
                }
                .conTextBold{
                    font-size: 2.125rem;
                    line-height: 2.125rem;
                    font-size: bold;
                    margin-bottom: 1.375rem;
                    color: #656565;
                }
                .conTextLow{
                    font-size: 1.5rem;
                    line-height: 1.5rem;
                    color: #999;
                }
                .conCenterTop{
                        margin-top: 2.125rem;
                    .conTextCenter{
                        margin-bottom: 2.3125rem;
                    }
                    .conTextLine{
                        width: 4.125rem;
                        height: .1875rem;
                        background: #018CF4;
                        margin: auto;
                    }
                }
                .conCenterCon{
                    padding: 0 1.25rem;
                    display: flex;
                    flex-direction: column;
                    .conNews{
                        height: 4.125rem;
                        display: flex;
                        justify-content: space-between;
                        border-bottom: .0625rem dotted #ccc;
                        line-height: 4.125rem;
                        p{
                            text-align: left;
                            width: 76%;
                            overflow: hidden;
                            font-size: 1rem;
                            color: #222;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            cursor: pointer;
                        }
                        span{
                            font-size: .8125rem;
                            color: #999
                        }
                    }
                    .conMore{
                        display: flex;
                        font-size: .8125rem;
                        color: #999;
                        margin-top: 1.25rem;
                        justify-content: flex-end;
                        p{
                            cursor: pointer;
                        }
                    }
                }
                
            }
            .conBox:nth-child(2){
                .conImg{
                    background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_xwdt.png)
                }
            }
            .conBox:last-child{
                .conImg{
                    background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yggh.png)
                }
            }
        }
    }
</style>